export const messages = {
  OPEN: 'e:confirm:open',
  RESPONSE: 'e:confirm:response'
};

export const types = {
  DESTRUCTIVE: 'destructive',
  CONSEQUENTIAL: 'consequential'
};
